import React from 'react';
import { useTranslation } from 'react-i18next';
import { View, Text } from '@react-pdf/renderer';
import FlatGlassStructureUtils from 'components/ThreeJs/assets/filter/Glass/FlatGlassStructureUtils';
import { formatNumberToFixedPdf as formatNumberToFixed } from 'utils';
import PdfGlassConfigDetailItem from './PdfGlassConfigDetailItem';

import styles from '../styles';

const PdfGlassConfigDetailSecond = ({ configDetails, showPrice, priceVolumeCat }) => {
	const { t } = useTranslation('commonConfigurationAction');
	const { sqmPrice } = configDetails.flatGlassStructure;
	const volDiscountSqmPrice = FlatGlassStructureUtils.getSqmPrice(
		configDetails.flatGlassStructure,
		priceVolumeCat
	);
	const hasPrice = sqmPrice !== null;
	const price = showPrice && (
		<View style={styles.glassConfigBlockPriceDiscountedView}>
			<Text style={styles.glassConfigBlockPriceDiscountedText}>
				{formatNumberToFixed(volDiscountSqmPrice || t('priceOnDemand'), 2, t('i18n:numberFormat'))}
			</Text>
		</View>
	);
	return (
		<View style={{ ...styles.glassConfigDetails, ...styles.glassConfigDetailsIndentState }}>
			<PdfGlassConfigDetailItem
				categoryLabel="fireResistanceClass"
				selected={configDetails.fireResistanceClass}
				secondLayoutOption
			/>
			<PdfGlassConfigDetailItem
				categoryLabel="manufacturer"
				selected={configDetails.manufacturer}
				secondLayoutOption
			/>
			<PdfGlassConfigDetailItem
				categoryLabel="whiteGlass"
				selected={configDetails.whiteGlass}
				secondLayoutOption
			/>
			<PdfGlassConfigDetailItem
				categoryLabel="application"
				selected={configDetails.application}
				secondLayoutOption
			/>
			<PdfGlassConfigDetailItem
				categoryLabel="structure"
				selected={configDetails.structure}
				secondLayoutOption
			/>
			<PdfGlassConfigDetailItem
				categoryLabel="insulation"
				selected={configDetails.insulation}
				secondLayoutOption
			/>
			<PdfGlassConfigDetailItem
				categoryLabel="sound"
				selected={configDetails.sound}
				secondLayoutOption
			/>
			<PdfGlassConfigDetailItem
				categoryLabel="resistanceClass"
				selected={configDetails.resistanceClass}
				secondLayoutOption
			/>
			<PdfGlassConfigDetailItem
				categoryLabel="buttJoints"
				selected={configDetails.buttJoints}
				secondLayoutOption
			/>
			<PdfGlassConfigDetailItem
				categoryLabel="sqmWeight"
				selected={formatNumberToFixed(
					configDetails.flatGlassStructure.sqmWeight,
					0,
					t('i18n:numberFormat')
				)}
				secondLayoutOption
			/>
			{showPrice && (
				<PdfGlassConfigDetailItem
					categoryLabel="sqmPrice"
					selectedItem={
						!hasPrice || priceVolumeCat === '0' || sqmPrice <= volDiscountSqmPrice ? (
							price
						) : (
							<View style={styles.glassConfigBlockPriceView}>
								<View style={styles.glassConfigBlockPriceFullView}>
									<Text style={styles.glassConfigBlockPriceFullText}>
										{formatNumberToFixed(sqmPrice || t('priceOnDemand'), 2, t('i18n:numberFormat'))}
									</Text>
								</View>
								{price}
							</View>
						)
					}
					secondLayoutOption
				/>
			)}
		</View>
	);
};

export default PdfGlassConfigDetailSecond;
